/**
 * Discarding a walkthrough deletes its video and everything made from it, and
 * cannot be undone, so every Discard asks first, in the same words (review of
 * 0.2.0, 3 Oct: the review page asked and the recorder page did not).
 *
 * Moments already filed as tickets during the recording are kept (TOADO-900):
 * they are real tickets, and Jira or a mention may already have acted on them.
 * The question says so, with how many, so nobody discards expecting them gone.
 */
export function discardWalkthroughQuestion(filedTickets = 0): string {
  if (filedTickets <= 0) return 'Discard this entire walkthrough and its private media?';
  const kept = filedTickets === 1
    ? 'The 1 ticket already filed from it stays on the board; delete it there if you do not want it.'
    : `The ${filedTickets} tickets already filed from it stay on the board; delete any you do not want there.`;
  return `Discard the rest of this walkthrough? ${kept}`;
}

export function confirmDiscardWalkthrough(filedTickets = 0): boolean {
  return window.confirm(discardWalkthroughQuestion(filedTickets));
}
